module.exports = __webpack_public_path__ + "img/Vector@2x.3d0c43ea.png";